import React from "react";
import { useTranslation } from "react-i18next";
import { HowItWorksComponentProps } from "../../constants/interface.ts";
import TitleParagraphComponent from '../../components/TitleParagraphComponent/TitleParagraphComponent.tsx';

const HowItWorksComponent = (props: HowItWorksComponentProps) => {
    const { title, img, list, paragraph = '' } = props;
    const {t} = useTranslation();
    
    return (
        <div className="max-w-[80rem] m-auto flex flex-col gap-8 lg:gap-16">
            <TitleParagraphComponent
                title={{
                    text: t(title),
                    className:`text-3xl font-semibold lg:text-4xl m-auto text-center`
                }}
                paragraph={{
                    text: t(paragraph) || '',
                    className:'max-w-[32rem] text-gray-535'
                }}
            />
            <div className="grid gap-8 lg:grid-cols-2 lg:gap-16">
                <div className="flex flex-col gap-8 lg:gap-11">
                    {
                        list.map((subItem, subIndex: number) => (
                            <div key={`1-${subIndex}`} className="flex gap-4">
                                {/* <div>
                                    <img loading="lazy" src={subItem.img} alt=""
                                        className="w-12 min-w-12"
                                    />
                                </div> */}
                                <div className={`p-3 w-fit h-fit rounded-[0.625rem] bg-white border border-gray-E9E`}>
                                    {
                                        (subItem.img)?
                                        (
                                            <img loading="lazy" src={subItem.img} alt={t(subItem.title)} className="w-6" />
                                        ) : (
                                            <span className="w-6 inline-block text-center text-base font-medium text-gray-414 leading-none">{(subIndex + 1).toString().padStart(2,'0')}</span>
                                        )
                                    }
                                </div>
                                <div className="grid gap-2">
                                    <p className="text-lg font-semibold text-black-1A1 lg:text-xl">{t(subItem.title)}</p>
                                    <p className="text-sm font-normal text-gray-666 lg:text-base">{t(subItem.paragraph)}</p>
                                </div>
                            </div>
                        ))
                    }
                </div>
                <div className="grid place-content-center">
                    <div className="relative m-8">
                        {/* rotated shadow effect */}
                        <div className="w-[12rem] h-[16rem] absolute inset-0 bg-gray-200 z-10 rotate-[17.41deg] rounded-lg lg:w-[16.25rem] lg:h-[20.5rem]" />
                        
                        {/* Base container with padding for shadow space */}
                        <div className="relative z-20 p-1 w-fit bg-white transition-transform duration-500"> {/* hover:rotate-[38deg] */}
                            {/* Main image */}
                            <img loading="lazy" src={img} alt="" 
                                className="w-[12rem] h-[16rem] object-cover rounded-lg lg:w-[16.25rem] lg:h-[20.5rem] bg-gray-DDE"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HowItWorksComponent;